export enum OverlayStatusEnum {
    Idle = 'Idle',
    Working = 'Working',
    Overlay = 'Overlay'
} 